import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import SweetAlert from "react-bootstrap-sweetalert";
import Header from "../../../components/dashboard/header";
import Footer from "../../../components/dashboard/footer";
import SideMenu from "../../student/SideMenu";
import Loader from "../../../components/loader";
import SessionPopup from "../../SessionPopup";
import { contentContext } from "../../../context/contentContext";

let { lambda, appname } = window.app;

const STATUS_COLORS = {
    "Draft":                       { background: "#6c757d" },
    "Submitted":                   { background: "#0d6efd" },
    "Under Lab Review":            { background: "#0dcaf0", color: "#000" },
    "Assigned to Pathologist":     { background: "#ffc107", color: "#000" },
    "Additional Test Requested":   { background: "#fd7e14" },
    "Additional Test In Progress": { background: "#6f42c1" },
    "Reassigned to Pathologist":   { background: "#20c997", color: "#000" },
    "Completed":                   { background: "#198754" },
    "Converted to Learning Case":  { background: "#0a58ca" },
};

export default function DoctorBiopsyView() {
    const { id } = useParams();
    const navigate = useNavigate();
    const token = localStorage.getItem("token");

    const {
        route, setRoute,
        setCurrentPage, setRowsPerPage,
        setActiveMenuObj, setActiveMenuId,
        usePrevious,
        GetTimeActivity,
    } = useContext(contentContext);

    const [caseDetails, setCaseDetails] = useState({});
    const [activeTab, setActiveTab] = useState("caseinfo");
    const [isLoading, setIsLoading] = useState(false);
    const [showSessionPopup, setShowSessionPopup] = useState(false);
    const [invalidContent, setInvalidContent] = useState(false);
    const [imageCloudfront, setImageCloudfront] = useState("");
    const [showImagePopup, setShowImagePopup] = useState(false);
    const [popupImageUrl, setPopupImageUrl] = useState(null);

    const prevRoute = usePrevious(route);
    useEffect(() => {
        if (prevRoute !== undefined && prevRoute !== route) {
            setCurrentPage(1);
            setRowsPerPage(15);
        }
    }, [prevRoute]);

    useEffect(() => {
        if (window.site?.common?.imageCloudfront) {
            setImageCloudfront(window.site.common.imageCloudfront);
        } else {
            setTimeout(() => {
                if (window.site?.common?.imageCloudfront) {
                    setImageCloudfront(window.site.common.imageCloudfront);
                }
            }, 1000);
        }
    }, [window.site]);

    useEffect(() => {
        if (!token) navigate("/");
        setActiveMenuId(200005);
        setActiveMenuObj({ "Client Management": false, "Contact Management": false, "Reports": false });
        setRoute("user");
        fetchCaseDetails();
    }, []);

    const fetchCaseDetails = () => {
        GetTimeActivity();
        setIsLoading(true);
        axios.get(`${lambda}/biopsyCaseInfo?appname=${appname}&patientid=${id}`)
            .then((res) => {
                if (res?.data?.result === "Invalid token or Expired") {
                    setShowSessionPopup(true);
                } else if (res?.data?.result?.length > 0) {
                    setCaseDetails(res.data.result[0]);
                } else {
                    setInvalidContent(true);
                }
                setIsLoading(false);
            })
            .catch(() => setIsLoading(false));
    };

    const handleBack = () => {
        GetTimeActivity();
        navigate("/biopsy/cases");
    };

    const handleImagePopup = (imageUrl) => {
        setShowImagePopup(true);
        setPopupImageUrl(imageUrl);
    };

    const renderStatusBadge = (status) => {
        if (!status) return null;
        const style = STATUS_COLORS[status] || { background: "#6c757d" };
        return (
            <span className="ms-3" style={{
                ...style,
                color: style.color || "#fff",
                fontSize: "12px",
                fontWeight: "600",
                padding: "3px 10px",
                borderRadius: "4px",
            }}>
                {status}
            </span>
        );
    };

    const readOnlyField = (label, value) => (
        <div className="col-lg-4 col-md-6 col-sm-12">
            <div className="mb-3 input-field">
                <label className="form_label">{label}</label>
                <input type="text" className="form-control" disabled value={value || ""} />
            </div>
        </div>
    );

    const readOnlyTextarea = (label, value, rows = 5) => (
        <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="mb-3 input-field">
                <label className="form_label">{label}</label>
                <textarea className="form-control edit-cpc-textarea" disabled rows={rows} value={value || ""} />
            </div>
        </div>
    );

    const isCompleted = caseDetails?.status === "Completed";
    console.log("caseDetails",caseDetails)
    return (
        <>
            {showSessionPopup && <SessionPopup />}

            <SweetAlert
                show={invalidContent}
                custom
                confirmBtnText="Ok"
                confirmBtnBsStyle="primary"
                title="Case Not Found"
                onConfirm={() => { setInvalidContent(false); navigate("/biopsy/cases"); }}
            />

            <div id="layout-wrapper">
                <Header />
                <SideMenu />

                {!invalidContent && (
                    <div className="main-content user-management create-user" id="main-content">
                        <div className="page-content">
                            <div className="container-fluid">
                                <div className="row mb-4 breadcrumb">
                                    <div className="col-lg-12">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-grow-1">
                                                <h4 className="mb-2 card-title">
                                                    VIEW
                                                    {renderStatusBadge(caseDetails?.status)}
                                                </h4>
                                                <p className="menu-path">
                                                    <span>BIOPSY</span> / <b>VIEW</b>
                                                </p>
                                            </div>
                                            <a onClick={handleBack} className="stroke-btn-style create-quiz-btn" style={{ cursor: "pointer" }}>
                                                Back
                                            </a>
                                        </div>
                                    </div>
                                </div>

                                <div className="row table-data">
                                    <div className="col-12">
                                        <div className="card">
                                            <div className="card-body cpc-management case-info edit-cpc">
                                                {isLoading ? <Loader /> : (
                                                    <>
                                                        {/* ── Tab Navigation ─────────────────────────────────────── */}
                                                        <ul className="nav nav-tabs nav-tabs-custom mb-4" role="tablist">
                                                            <li className="nav-item" role="presentation">
                                                                <button
                                                                    className={`nav-link ${activeTab === "caseinfo" ? "active" : ""}`}
                                                                    onClick={() => setActiveTab("caseinfo")}
                                                                >
                                                                    <span className="d-none d-sm-block">CASE INFO</span>
                                                                </button>
                                                            </li>
                                                            <li className="nav-item" role="presentation">
                                                                <button
                                                                    className={`nav-link ${activeTab === "photos" ? "active" : ""}`}
                                                                    onClick={() => setActiveTab("photos")}
                                                                >
                                                                    <span className="d-none d-sm-block">CLINICAL PHOTOS</span>
                                                                </button>
                                                            </li>
                                                            {isCompleted && (
                                                                <li className="nav-item" role="presentation">
                                                                    <button
                                                                        className={`nav-link ${activeTab === "report" ? "active" : ""}`}
                                                                        onClick={() => setActiveTab("report")}
                                                                    >
                                                                        <span className="d-none d-sm-block">REPORT</span>
                                                                    </button>
                                                                </li>
                                                            )}
                                                        </ul>

                                                        {/* ── CASE INFO Tab ───────────────────────────────────────── */}
                                                        {activeTab === "caseinfo" && (
                                                            <div className="create-user-block">
                                                                {Object.keys(caseDetails).length > 0 ? (
                                                                    <div className="form-block">
                                                                        <div className="row col-lg-12">
                                                                            {readOnlyField("PATH REF NO", caseDetails.pathrefno)}
                                                                            {readOnlyField("BIOPSY DATE", caseDetails.biopsydate)}
                                                                            {readOnlyField("PATIENT NAME", caseDetails.patientname)}
                                                                            {readOnlyField("AGE", caseDetails.age)}
                                                                            {readOnlyField("GENDER", caseDetails.gender)}
                                                                            {readOnlyField("CLINIC REGISTRATION NUMBER", caseDetails.clinicregistrationnumber)}
                                                                            {readOnlyField("SPECIMEN TYPE", caseDetails.specimentype)}
                                                                            {readOnlyField("SITE OF BIOPSY", caseDetails.siteofbiopsy)}
                                                                            {readOnlyField("BIOPSY TYPE", caseDetails.biopsyType?.label)}
                                                                            {readOnlyTextarea("CLINICAL HISTORY", caseDetails.clinicalhistory)}

                                                                            {/* TESTS / SLIDES — read-only inline display */}
                                                                            {(caseDetails.defaultBiopsyTest?.name || caseDetails.defaultBiopsyTest?.cost) && (
                                                                                <div className="col-lg-12 mb-3">
                                                                                    <label className="form_label">TESTS / SLIDES</label>
                                                                                    <div className="d-flex align-items-center gap-3 mt-2 flex-wrap">
                                                                                        <div>
                                                                                            <label className="form_label mb-1" style={{ fontSize: "12px" }}>TEST NAME</label>
                                                                                            <input
                                                                                                type="text"
                                                                                                className="form-control form-control-sm"
                                                                                                style={{ width: "200px" }}
                                                                                                disabled
                                                                                                value={caseDetails.defaultBiopsyTest?.name || ""}
                                                                                            />
                                                                                        </div>
                                                                                        <div>
                                                                                            <label className="form_label mb-1" style={{ fontSize: "12px" }}>COST (₹)</label>
                                                                                            <input
                                                                                                type="text"
                                                                                                className="form-control form-control-sm"
                                                                                                style={{ width: "140px" }}
                                                                                                disabled
                                                                                                value={caseDetails.defaultBiopsyTest?.cost || "—"}
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            )}

                                                                            {/* ADDITIONAL TESTS — read-only */}
                                                                            {caseDetails.additionalTests?.length > 0 && (
                                                                                <div className="col-lg-12 mb-3">
                                                                                    <label className="form_label">ADDITIONAL TESTS</label>
                                                                                    <table className="table table-bordered" style={{ maxWidth: "600px" }}>
                                                                                        <thead style={{ background: "#f8f9fa" }}>
                                                                                            <tr>
                                                                                                <th style={{ fontWeight: "600", fontSize: "13px" }}>Test Name</th>
                                                                                                <th style={{ fontWeight: "600", fontSize: "13px" }}>Fee (₹)</th>
                                                                                            </tr>
                                                                                        </thead>
                                                                                        <tbody>
                                                                                            {caseDetails.additionalTests.map((t, index) => (
                                                                                                <tr key={`${t.name}-${index}`}>
                                                                                                    <td style={{ fontSize: "13px" }}>{t.name}</td>
                                                                                                    <td style={{ fontSize: "13px" }}>{t.fee}</td>
                                                                                                </tr>
                                                                                            ))}
                                                                                        </tbody>
                                                                                        <tfoot>
                                                                                            <tr style={{ background: "#f8f9fa" }}>
                                                                                                <td style={{ fontWeight: "700", fontSize: "13px" }}>Total</td>
                                                                                                <td style={{ fontWeight: "700", fontSize: "13px" }}>
                                                                                                    ₹ {caseDetails.additionalTests.reduce((sum, t) => sum + (parseFloat(t.fee) || 0), 0)}
                                                                                                </td>
                                                                                            </tr>
                                                                                        </tfoot>
                                                                                    </table>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                ) : (
                                                                    <Loader />
                                                                )}
                                                            </div>
                                                        )}

                                                        {/* ── CLINICAL PHOTOS Tab ─────────────────────────────────── */}
                                                        {activeTab === "photos" && (
                                                            <div>
                                                                <p className="mt-0 mb-0 text-muted file-format">Note: File size: 20 MB | Supported Formats: JPG, PNG</p>
                                                                <div className="d-flex justify-content-start col-lg-12 clinical-photo-section gap-3 mt-3">
                                                                    <div className="uploaded_images-grid mb-3 mt-2">
                                                                        {caseDetails?.biopsyfiles?.length > 0 ? (
                                                                            caseDetails.biopsyfiles.map((item, key) => {
                                                                                const imgPath = `${imageCloudfront}${item?.sourcepath?.replace(/ /g, "%20")}?auto=compress,format`;
                                                                                return (
                                                                                    <div className="thumb-box" key={key}>
                                                                                        <div
                                                                                            className="thumb-img cursor-pointer"
                                                                                            onClick={() => handleImagePopup(imgPath)}
                                                                                        >
                                                                                            <img src={`${imgPath}&width=150`} alt={item.filename} />
                                                                                        </div>
                                                                                        <p className="thumb-name text-truncate small mb-0">{item.filename}</p>
                                                                                    </div>
                                                                                );
                                                                            })
                                                                        ) : (
                                                                            <p className="text-muted small">No clinical photos uploaded.</p>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}

                                                        {/* ── REPORT Tab (Completed cases only) ───────────────────── */}
                                                        {activeTab === "report" && isCompleted && (
                                                            <div className="create-user-block">
                                                                <div className="form-block">
                                                                    <div className="row col-lg-12">
                                                                        <div className="col-lg-12 mb-2">
                                                                            <div className="d-flex align-items-center gap-2">
                                                                                <span className="material-icons" style={{ color: "#198754" }}>check_circle</span>
                                                                                <span style={{ fontWeight: "600", color: "#198754" }}>Case Completed — Final Report</span>
                                                                            </div>
                                                                            <hr />
                                                                        </div>

                                                                        <div className="col-lg-12 col-md-12 col-sm-12">
                                                                            <div className="mb-3 input-field">
                                                                                <label className="form_label">DIAGNOSIS</label>
                                                                                <textarea
                                                                                    className="form-control edit-cpc-textarea"
                                                                                    rows={4}
                                                                                    disabled
                                                                                    value={caseDetails.diagnosis || ""}
                                                                                    placeholder="No diagnosis recorded"
                                                                                />
                                                                            </div>
                                                                        </div>

                                                                        <div className="col-lg-12 col-md-12 col-sm-12">
                                                                            <div className="mb-3 input-field">
                                                                                <label className="form_label">HISTOPATHOLOGY FINDINGS</label>
                                                                                <textarea
                                                                                    className="form-control edit-cpc-textarea"
                                                                                    rows={4}
                                                                                    disabled
                                                                                    value={caseDetails.histopathologyFindings || ""}
                                                                                    placeholder="No findings recorded"
                                                                                />
                                                                            </div>
                                                                        </div>

                                                                        <div className="col-lg-12 col-md-12 col-sm-12">
                                                                            <div className="mb-3 input-field">
                                                                                <label className="form_label">NOTES / REMARKS</label>
                                                                                <textarea
                                                                                    className="form-control edit-cpc-textarea"
                                                                                    rows={3}
                                                                                    disabled
                                                                                    value={caseDetails.notes || ""}
                                                                                    placeholder="No notes recorded"
                                                                                />
                                                                            </div>
                                                                        </div>

                                                                        {/* ADDITIONAL TESTS — read-only */}
                                                                        {caseDetails.additionalTests?.length > 0 && (
                                                                            <div className="col-lg-12 mb-3">
                                                                                <label className="form_label">ADDITIONAL TESTS</label>
                                                                                <table className="table table-bordered" style={{ maxWidth: "600px" }}>
                                                                                    <thead style={{ background: "#f8f9fa" }}>
                                                                                        <tr>
                                                                                            <th style={{ fontWeight: "600", fontSize: "13px" }}>Test Name</th>
                                                                                            <th style={{ fontWeight: "600", fontSize: "13px" }}>Fee (₹)</th>
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        {caseDetails.additionalTests.map((t, index) => (
                                                                                            <tr key={`${t.name}-${index}`}>
                                                                                                <td style={{ fontSize: "13px" }}>{t.name}</td>
                                                                                                <td style={{ fontSize: "13px" }}>{t.fee}</td>
                                                                                            </tr>
                                                                                        ))}
                                                                                    </tbody>
                                                                                    <tfoot>
                                                                                        <tr style={{ background: "#f8f9fa" }}>
                                                                                            <td style={{ fontWeight: "700", fontSize: "13px" }}>Total</td>
                                                                                            <td style={{ fontWeight: "700", fontSize: "13px" }}>
                                                                                                ₹ {caseDetails.additionalTests.reduce((sum, t) => sum + (parseFloat(t.fee) || 0), 0)}
                                                                                            </td>
                                                                                        </tr>
                                                                                    </tfoot>
                                                                                </table>
                                                                            </div>
                                                                        )}

                                                                        {/* TESTS / SLIDES — read-only */}
                                                                        {(caseDetails.defaultBiopsyTest?.name || caseDetails.defaultBiopsyTest?.cost) && (
                                                                            <div className="col-lg-12 mb-3">
                                                                                <label className="form_label">TESTS / SLIDES</label>
                                                                                <div className="d-flex align-items-center gap-3 mt-2 flex-wrap">
                                                                                    <div>
                                                                                        <label className="form_label mb-1" style={{ fontSize: "12px" }}>TEST NAME</label>
                                                                                        <input
                                                                                            type="text"
                                                                                            className="form-control form-control-sm"
                                                                                            style={{ width: "200px" }}
                                                                                            disabled
                                                                                            value={caseDetails.defaultBiopsyTest?.name || ""}
                                                                                        />
                                                                                    </div>
                                                                                    <div>
                                                                                        <label className="form_label mb-1" style={{ fontSize: "12px" }}>COST (₹)</label>
                                                                                        <input
                                                                                            type="text"
                                                                                            className="form-control form-control-sm"
                                                                                            style={{ width: "140px" }}
                                                                                            disabled
                                                                                            value={caseDetails.defaultBiopsyTest?.cost || "—"}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Footer />
                    </div>
                )}
            </div>

            {/* Image popup lightbox */}
            {showImagePopup && (
                <div
                    style={{
                        position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
                        backgroundColor: "rgba(0,0,0,0.8)", zIndex: 1003,
                        display: "flex", alignItems: "start", justifyContent: "center", padding: "20px",
                    }}
                    onClick={() => setShowImagePopup(false)}
                >
                    <div
                        style={{ position: "relative", height: "100%", padding: "20px", display: "flex", justifyContent: "center", alignItems: "start" }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <img src={popupImageUrl} style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain", display: "block" }} />
                        <button
                            onClick={() => setShowImagePopup(false)}
                            style={{ position: "absolute", top: "10px", right: "10px", background: "white", border: "none", borderRadius: "50%", width: "30px", height: "30px", cursor: "pointer", fontWeight: "bold" }}
                        >×</button>
                    </div>
                </div>
            )}
        </>
    );
}
